var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33605 0.739145C2.75026 0.153358 1.80052 0.153358 1.21473 0.739145C0.628944 1.32493 0.628944 2.27468 1.21473 2.86046L5.35427 7L1.21512 11.1391C0.629335 11.7249 0.629335 12.6747 1.21512 13.2605C1.80091 13.8463 2.75066 13.8463 3.33644 13.2605L7.47559 9.12132L11.6147 13.2605C12.2005 13.8463 13.1503 13.8463 13.7361 13.2605C14.3218 12.6747 14.3218 11.7249 13.7361 11.1391L9.59691 7L13.7364 2.86046C14.3222 2.27468 14.3222 1.32493 13.7364 0.739145C13.1507 0.153358 12.2009 0.153358 11.6151 0.739145L7.47559 4.87868L3.33605 0.739145Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnion);
export default __webpack_public_path__ + "static/media/ic-union.2ae4a895e12670c480564e16cba13d35.svg";
export { ForwardRef as ReactComponent };